<template>
  <div class="tenantLog">
    <div class="head-box">
      <h4>{{ params.title || '系统日志' }}</h4>
      <div class="c-flex c-flex-item c_w" style="overflow-x:auto;">
        <el-date-picker
          style="min-width: 340px;"
          v-model="search.date"
          type="datetimerange"
          :picker-options="date.pickerOptions"
          start-placeholder="创建时间开始"
          end-placeholder="创建时间结束"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
          class="search-date"
        ></el-date-picker>
        <el-select
          v-if="!params.smodule_hide"
          style="min-width: 250px;"
          v-model="search.smodule"
          clearable
          allow-create
          filterable
          placeholder="请选择功能模块"
          class="c-m-l-10"
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="item in options.smodule"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-if="!params.sid_hide"
          style="min-width: 200px;"
          placeholder="搜索数据ID"
          v-model="search.sid"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-input
          style="min-width: 200px;"
          placeholder="搜索日志名称/内容"
          v-model="search.value"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          :data="fpi.data"
          ref="table"
          style="width: 100%"
          height="calc(100% - 50px)"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column
            property="title"
            label="日志名称"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="smodule"
            label="功能模块"
            width="100px"
            :formatter="formatSmodule"
          ></el-table-column>
          <el-table-column property="sid" label="数据ID" width="150px"></el-table-column>
          <el-table-column property="createTime" label="创建时间" width="150px"></el-table-column>
          <el-table-column
            property="content"
            label="日志内容"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'TenantLog',
  inject: ['viewReload'],
  data() {
    window.$this = this;
    return {
      params: {},
      title: '',
      search: { smodule: '', sid: '', date: [], value: '' },
      options: {
        codecfg_smodule: { codeId: 'smodule' }
      },
      fpi: {}
    };
  },
  mounted() {
    this.params = this.osg.paramObj();
    this.osg.codeoption(() => {
      this.search.smodule = this.params.smodule || '';
      this.search.sid = this.params.sid || '';
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      this.search.date = this.search.date || [];
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        sortField: this.params.sortField || 'createTime',
        sortOrder: this.params.sortOrder || 'desc',
        smodule: this.search.smodule,
        sid: this.search.sid,
        'gte:createTime|datetime#and': this.search.date[0],
        'lte:createTime|datetime#and': this.search.date[1],
        'regex:title|string#or': this.search.value,
        'regex:content|string#or': this.search.value
      };
      this.osg.setFpi(params);
      this.osg.ajax('tenantLog/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    formatSmodule(row, column, cellValue) {
      return this.osg.codelabel('smodule', cellValue);
    }
  }
  // watch: {
  //   $route() {
  //     window.$this = this;
  //     this.viewReload();
  //   }
  // }
};
</script>
